import { BaseButton, type BaseButtonProps } from './BaseButton'

export type ButtonProps =
  | ({
      variant?: 'text' // default variant is `text`

      /**
       * Its only possible to set a text variant in square mode
       */
      isSquare?: boolean
    } & Omit<BaseButtonProps, 'variant'>)
  | ({
      variant: 'outlined'
    } & Omit<BaseButtonProps, 'variant' | 'dense' | 'isSquare'>)
  | ({
      variant: 'contained'
    } & Omit<BaseButtonProps, 'variant' | 'dense' | 'isSquare'>)

export const Button = (props: ButtonProps) => <BaseButton {...props} />
